import { useEffect } from 'react';

import Toolbar from '@lcsc-ui/components/ToolBar';
import BaseLayout from '@lcsc-ui/layouts/baseLayout';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import ecpCurl from '@lcsc-ui/utils/ecpCurl';
import Head from 'next/head';
import { NextSeo } from 'next-seo';

import MarketApi from '@/apis/market';
import OpApi from '@/apis/op';
import StaticdataApi from '@/apis/staticdata';
import GetCoupons from '@/features/huodong';

const metadata = {
  title: ' 立创元器件优惠券-优惠活动专区-立创商城',
  additionalMetaTags: [
    {
      name: 'keywords',
      content: '立创商城,元器件,电子元器件,电子元器件商城,电子元器件采购网,嘉立创',
    },
    {
      name: 'description',
      content:
        '立创商城SZLCSC.COM一站式电子元器件采购自营商城，拥有13万+平米智能化仓储，海量现货，正品保证，支持一键BOM配单，最快4小时发货，为用户提供电子元器件线上采购服务。嘉立创集团提供“EDA软件/PCB CAM软件、PCB智造、元器件商城、 激光钢网/治具 、SMT贴片”为一体的电子全产业链服务，助力全球硬件创新。',
    },
  ],
};

const GetCouponsPage = (props) => {
  const { resourceData, websiteSectionList, catalogList, headerAd, renderSuccess } = props;

  useEffect(() => {
    buriedPoint({
      ty: 'enter',
      op: 'view',
      cp: 'coupon_center',
      pf: 'pc',
    });
  }, []);

  return (
    <>
      <NextSeo title={metadata.title} additionalMetaTags={metadata.additionalMetaTags} />
      <Head>
        <link
          rel="preload"
          href="//static.szlcsc.com/ecp/assets/newWeb/www/lingquan/lq-sort-arrow-active.svg"
          as="image"
        />
        <link
          rel="preload"
          href="//static.szlcsc.com/ecp/assets/web/page/www/get-coupons/images/clear.svg"
          as="image"
        />
        <link
          rel="preload"
          href="//static.szlcsc.com/ecp/assets/web/page/www/get-coupons/images/clear-a.svg"
          as="image"
        />
        <link
          rel="preload"
          href="//static.szlcsc.com/ecp/assets/web/page/www/get-coupons/images/close.svg"
          as="image"
        />
        <link
          rel="preload"
          href="//static.szlcsc.com/ecp/assets/web/page/www/get-coupons/images/search-a.svg"
          as="image"
        />
        <link rel="preload" href="//static.szlcsc.com/ecp/assets/newWeb/www/lingquan/lq-yhq-bg.svg" as="image" />
        <link rel="canonical" href={`${resourceData?.projectConfigVO.lcscWwwUrl}/huodong.html`} />
        {renderSuccess && <meta name="lcscRender" content="true" />}
      </Head>
      <BaseLayout
        resourceData={resourceData}
        websiteSectionList={websiteSectionList}
        catalogList={catalogList}
        headerAd={headerAd}
        isLgScreen={false}
        notIndexHeaderAdapter
        onlySScreen
        isNeedTopAd={true}
        isShowBottomAd={true}
      >
        <GetCoupons {...props} />
        <Toolbar />
      </BaseLayout>
    </>
  );
};

export default GetCouponsPage;

export async function getServerSideProps(context) {
  const { req } = context;
  const CouponsApiResults = await Promise.allSettled([
    ecpCurl(StaticdataApi.resourceList),
    ecpCurl(StaticdataApi.catalogList),
    ecpCurl(OpApi.websiteSection),
    ecpCurl(OpApi.advertisingHeader),
    ecpCurl(MarketApi.getCouponOptions, { headers: req.headers }),
    ecpCurl(MarketApi.getPartitionList, { headers: req.headers }),
    ecpCurl(MarketApi.getCouponsDataList, { headers: req.headers }),
  ]);
  const [resourceData, catalogList, websiteSectionList, headerAd, couponOptions, partitionList, couponsDataList] =
    CouponsApiResults.map((result) => {
      if (result.status === 'fulfilled') {
        return result.value;
      }
      return null;
    });
  const renderSuccess = CouponsApiResults.every((result) => result.status === 'fulfilled');

  return {
    props: {
      resourceData,
      websiteSectionList,
      catalogList,
      headerAd,
      couponBrandList: couponOptions?.brandGroup,
      couponTypeList: couponOptions?.couponTypeList,
      couponCatalogList: couponOptions?.catalogGroup,
      renderSuccess,
      partitionList,
      couponsDataList,
    },
  };
}
